import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import CoverSection from "@/pages/ph360/CoverSection";

export default function TabBook({ project, onChange }) {
  const [b, setB] = useState(project.book_info);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ph360/settings/book", b);
      onChange(data);
      toast.success("Book info saved");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  const F = (label, key, testid, type="text") => (
    <>
      <label>{label}</label>
      <input type={type} value={b[key] || ""} onChange={(e)=>setB({...b,[key]:e.target.value})} data-testid={`book-${testid}`}/>
    </>
  );
  return (
    <>
      <h2>Book Information</h2>
      {F("Title","title","title")}
      <label>Subtitle</label>
      <textarea rows={2} value={b.subtitle||""} onChange={(e)=>setB({...b,subtitle:e.target.value})} data-testid="book-subtitle"/>
      {F("Author","author","author")}
      {F("Publisher","publisher","publisher")}
      {F("Imprint","imprint","imprint")}
      {F("Copyright Year","copyright_year","copyright_year")}
      {F("Website","website","website","url")}
      {F("Email","email","email","email")}
      {F("ISBN (Optional)","isbn","isbn")}
      <p style={{marginTop:14}}>
        <button className="button button-primary" onClick={save} disabled={busy} data-testid="book-save">
          {busy ? "Saving…" : "Save Book Info"}
        </button>
      </p>
      <CoverSection project={project} onChange={onChange} />
    </>
  );
}
